/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadScoreReasonFromJSON, ApiLeadScoreReasonToJSON, } from './ApiLeadScoreReason';
export function ApiUserActionLeadScoreFromJSON(json) {
    return ApiUserActionLeadScoreFromJSONTyped(json, false);
}
export function ApiUserActionLeadScoreFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'diff': !exists(json, 'diff') ? undefined : json['diff'],
        'reason': !exists(json, 'reason') ? undefined : ApiLeadScoreReasonFromJSON(json['reason']),
    };
}
export function ApiUserActionLeadScoreToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'diff': value.diff,
        'reason': ApiLeadScoreReasonToJSON(value.reason),
    };
}
